import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { navLinks } from "@/mocks/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (item: { label: string; path: string }) => {
    setMobileOpen(false);
    setMenuOpen(false);
    if (item.path.startsWith("/#")) {
      navigate(item.path);
      return;
    }
    navigate(item.path);
    window.scrollTo({ top: 0 });
  };

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-primary-500 text-background-50">
        <div className="mx-auto flex h-9 max-w-7xl items-center justify-between px-4 md:px-6 text-[13px]">
          <div className="flex items-center gap-2 overflow-hidden">
            <i className="ri-flashlight-fill text-accent-400"></i>
            <span className="whitespace-nowrap hidden sm:inline">今日快讯 · 实时跟进 · 新鲜抢先看</span>
            <span className="whitespace-nowrap sm:hidden">今日快讯实时跟进</span>
          </div>
          <div className="flex items-center gap-4 whitespace-nowrap">
            <span className="hidden md:inline-flex items-center gap-1.5">
              <i className="ri-database-2-line"></i> 数据实时更新中
            </span>
            <button
              onClick={() => go({ label: "订阅", path: "/#subscribe" })}
              className="hidden sm:inline-flex items-center gap-1.5 rounded-md bg-background-50/15 px-2.5 py-1 hover:bg-background-50/25 transition-colors"
            >
              <i className="ri-notification-3-line"></i> 订阅快讯
            </button>
          </div>
        </div>
      </div>

      <div
        className={`transition-all duration-300 ${
          scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200/80 shadow-sm" : "bg-background-50/70 backdrop-blur border-b border-background-100"
        }`}
      >
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
          <button
            onClick={() => go({ label: "首页", path: "/" })}
            className="flex items-center gap-2.5 whitespace-nowrap cursor-pointer"
            aria-label="海角爆料 首页"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-xl"></i>
            </span>
            <span className="text-left leading-none">
              <span className="block font-heading text-2xl font-black text-foreground-950">
                海角<span className="text-primary-500">爆</span>
              </span>
              <span className="block text-[11px] tracking-wide text-foreground-500 mt-0.5">吃瓜追更 · 新鲜快讯</span>
            </span>
          </button>

          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => go(link)}
                className="px-3 py-2 rounded-md text-sm font-medium text-foreground-800 hover:bg-background-100 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <div className="hidden md:flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1.5 border border-background-200/70">
              <i className="ri-search-line text-foreground-500"></i>
              <input
                type="text"
                placeholder="搜索快讯…"
                className="bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-400 w-32"
                aria-label="搜索"
              />
            </div>
            <button
              onClick={() => setMenuOpen(true)}
              className="hidden md:inline-flex whitespace-nowrap items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 hover:bg-primary-600 transition-colors"
            >
              <i className="ri-megaphone-line"></i> 我要爆料
            </button>
            <button
              className="lg:hidden flex h-10 w-10 items-center justify-center rounded-lg bg-background-100 text-foreground-800 cursor-pointer"
              onClick={() => setMobileOpen((v) => !v)}
              aria-label="打开菜单"
            >
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <nav
          className="lg:hidden bg-background-50 border-b border-background-200 px-4 pb-4"
          aria-label="移动端导航"
        >
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => go(link)}
                className="text-left px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100 cursor-pointer"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => {
                setMobileOpen(false);
                setMenuOpen(true);
              }}
              className="text-left px-3 py-2.5 rounded-lg text-sm font-medium text-primary-600 hover:bg-background-100 cursor-pointer"
            >
              我要爆料
            </button>
          </div>
        </nav>
      )}

      {menuOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-foreground-950/60 p-4" onClick={() => setMenuOpen(false)}>
          <div
            className="w-full max-w-lg rounded-2xl bg-background-50 p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-xl font-bold text-foreground-950">我要爆料</h3>
              <button
                onClick={() => setMenuOpen(false)}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-600 cursor-pointer"
                aria-label="关闭"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              欢迎提供新鲜快讯线索。请确保内容真实可靠，本平台将在核实后第一时间跟进发布。你也可以直接发送邮件给我们。
            </p>
            <a
              href="mailto:hello@capbao.example"
              className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-mail-send-line"></i> hello@capbao.example
            </a>
          </div>
        </div>
      )}
    </header>
  );
}